import Resume from 'src/assets/icons/customIcons/page-icons/Resume'
import { useLocale } from 'src/hooks/locale/locale'
import { useTranslatable } from 'src/hooks/locale/utils'
import SubPageLayout from 'src/views/includes/SubPageLayout'

export default function StudentResumeLayout(): JSX.Element | null {
  const t = useTranslatable()
  const locale = useLocale()

  const subBreadcrumbsItems = [{ page: `${t('resume:resume')}`, path: `/${locale}/student/resume` }]

  return (
    <SubPageLayout
      Icon={Resume}
      title={t('resume:resume')}
      subBreadcrubms={subBreadcrumbsItems}
      pages={[
        {
          title: t('resumeLayout:personal_information'),
          link: 'personal',
        },
        {
          title: t('resumeLayout:education'),
          link: 'education',
        },
        {
          title: t('resumeLayout:work_experience'),
          link: 'work',
        },
        {
          title: t('resumeLayout:trainings_seminars_workshops'),
          link: 'trainings',
        },
        {
          title: t('resumeLayout:personal_skills'),
          link: 'skills',
        },
        {
          title: t('resumeLayout:additional_info'),
          link: 'additional',
        },
        {
          title: t('resumeLayout:resume_summary'),
          link: 'summary',
        },
      ]}
    />
  )
}
